import {usePlaneduHttpService} from "../service/planedu.http.service";
import { BankEntity } from "../entity/bank.entity";

export function useBankRepository() {
  const httpService = usePlaneduHttpService<BankEntity>('bank');
  return {
    ...httpService
  }
}